import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next"; 
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const TopSellingProdTable = ({ sellsItem, inventories }) => {
  const { t } = useTranslation();
  const _store = useSelector((state) => state.pos.defStore);

  const [topSellingProds, setTopSellingProds] = useState([]);
  const [period, setPeriod] = useState("month");

  useEffect(() => {
    const filteredProds = [];
    const now = new Date();

    const startDate = new Date(now.getFullYear(), 0, 1);

    if (period === "month") {
      startDate.setMonth(now.getMonth(), 1);
    } else if (period === "quarter") {
      startDate.setMonth(Math.floor(now.getMonth() / 3) * 3, 1);
    } else if (period === "6months") {
      startDate.setMonth(now.getMonth() - 5, 1);
    }

    const _prods = sellsItem.filter((j) => {
      if (j.itemType !== 1) return false;

      const sellDate = new Date(`${j.sellDate}Z`);

      return sellDate >= startDate && sellDate <= now;
    });

    // Push Product
    _prods.forEach((j) => {
      var prod = _prods.filter((x) => x.product.id === j.product.id);
      // Check the product list is exist in the list before push to the list.
      !filteredProds.some((x) => JSON.stringify(x) === JSON.stringify(prod)) &&
        filteredProds.push(prod);
    });

    setTopSellingProds(
      filteredProds
        .sort(
          (f, s) =>
            s.map((j) => j.qty).reduce((x, y) => x + y, 0) -
            f.map((j) => j.qty).reduce((x, y) => x + y, 0)
        )
        .slice(0, 20)
    );
  }, [sellsItem, period]);

  return (
    <Paper className="br-8 shadow-xs pb-10">

    <Box
      className="d-flex a-center"
      sx={{
        justifyContent: "space-between",
        padding: "15px",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <Typography variant="h6" className="fs-16 fw-5 gray-color">
        {t("top20SellingProducts")}
      </Typography>

      <FormControl>
        <RadioGroup
          row
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <FormControlLabel
            value="month"
            control={<Radio size="small" />}
            label={t("month")}
          />
          <FormControlLabel
            value="quarter"
            control={<Radio size="small" />}
            label={t("quarter")}
          />
          <FormControlLabel
            value="6months"
            control={<Radio size="small" />}
            label={t("sixMonths")}
          />
          <FormControlLabel
            value="year"
            control={<Radio size="small" />}
            label={t("year")}
          />
        </RadioGroup>
      </FormControl>
    </Box>

      <TableContainer sx={{ maxHeight: "310px" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                  fontSize: "15px",
                  minWidth: "80px",
                  padding: "8px 8px",
                }}
              >
                {t("productName")}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "15px",
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                  minWidth: "80px",
                  padding: "8px 8px",
                }}
              >
                {t("unitSell")}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "15px",
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                  minWidth: "80px",
                  padding: "8px 8px",
                }}
              >
                {t("unitCost")}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "15px",
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                  minWidth: "80px",
                  padding: "8px 8px",
                }}
              >
                {t("unitProfit")}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "15px",
                  backgroundColor: "var(--primary-color)",
                  color: "var(--white-color)",
                  minWidth: "80px",
                  padding: "8px 8px",
                }}
              >
                {t("totalOnStock")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ height: "200px" }}>
            {topSellingProds.map((item, i) => (
              <TableRow hover key={i}>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    padding: "6px 8px 6px 8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item[0].product.name}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    padding: "6px 8px 6px 8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.map((j) => j.qty).reduce((x, y) => x + y, 0)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    padding: "6px 8px 6px 8px",
                    whiteSpace: "nowrap",
                  }}
                >
                 {formatCurrency(
                    item.reduce(
                      (sum, j) => sum + Number(j.qty || 0) * Number(j.price || 0),
                      0
                    ),
                    _store
                  )}

                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    padding: "6px 8px 6px 8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatCurrency(
                    item.reduce(
                      (sum, j) =>
                        sum +
                        Number(j.qty || 0) *
                          (Number(j.sellPrice || 0) -
                            Number(j.purchPrice || 0)),
                      0
                    ),
                    _store
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    padding: "6px 16px 6px 16px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {inventories.find((j) => j.productId === item[0].productId) &&
                    inventories.find((j) => j.productId === item[0].productId)
                      .inInventory}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TopSellingProdTable;
